import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Typography, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { PreviewAddress } from "pagesV2/pro/Experiences/ListingPreview/PreviewAddress";
import { PreviewMediaListing } from "pagesV2/pro/Experiences/ListingPreview/PreviewMedia";
import PreviewAbout from "pagesV2/pro/Experiences/ListingPreview/PreviewAbout";
import { PreviewMeetingLocation } from "pagesV2/pro/Experiences/ListingPreview/PreviewMeetingLocation";
import { PreviewGuide } from "pagesV2/pro/Experiences/ListingPreview/PreviewGuide";
import EmbeddedBookingLayout from "../EmbeddedBookingLayout";
import { PageName } from "ui/PageName";
import { routes } from "router";
import BookingDetailCard from "../ExperienceBooking/BookingDetailCard";
import { fetchExperienceById } from "store/experiences";
import styles from "../ExperienceListing/ExperienceListing.module.css"

const { Title } = Typography

const EmbeddedExperienceDetail = () => {
    const dispatch = useDispatch()
    const [t] = useTranslation()
    const { uuid, id } = useParams()
    const { loading, experienceDetail } = useSelector((state) => state?.experiences?.experienceById)

    useEffect(() => {
        if (id) {
            dispatch(fetchExperienceById(id))
        }
    }, [id, dispatch])

    return (
        <>
            {loading && (
                <div className={styles.loaderOverlay}>
                    <Spin size="large" />
                </div>
            )}
            <EmbeddedBookingLayout type={"experience_detail"}>
                <PageName title={"Experience Detail"} backPath={routes.embeddedExperienceListing({ uuid: uuid })} type={"embedded"} />
                <div style={{ position: "relative", paddingRight: "100px", marginTop: "40px" }}>
                    <Title level={2} style={{ lineHeight: 1, marginBottom: 0 }}>
                        {experienceDetail?.title}
                    </Title>
                </div>
                <PreviewAddress trip={experienceDetail} t={t} />
                <PreviewMediaListing trip={experienceDetail} />
                <Row gutter={[50, 10]}>
                    <Col span={24} lg={16} className="mb-l">
                        <PreviewAbout trip={experienceDetail} t={t} />
                        <PreviewMeetingLocation trip={experienceDetail} t={t} />
                        <PreviewGuide trip={experienceDetail} t={t} mode={"embedded"} />
                    </Col>
                    <Col span={24} lg={8} style={{ paddingTop: "40px" }}>
                        <BookingDetailCard bookNow={true} trip={experienceDetail} bookingButtonVisible={true} />
                    </Col>
                </Row>
            </EmbeddedBookingLayout>
        </>
    )
}

export default EmbeddedExperienceDetail